/**
 * PersonaSlice — registry of council members + roundtable seat order.
 * Invariants: hydration is idempotent; seatOrder must be a permutation of personas.keys().
 */
import type { StateCreator } from "zustand";
import type { Persona } from "../../domain/types";
import type { DebateStore } from "../debateStore";

export interface PersonaSlice {
  personas: Record<string, Persona>;
  seatOrder: string[];
  hydratePersonas(payload: { personas: Persona[]; seatOrder: string[] }): void;
  resetPersonas(): void;
}

export type PersonaSliceCreator = StateCreator<
  DebateStore,
  [["zustand/immer", never]],
  [],
  PersonaSlice
>;

export const createPersonaSlice: PersonaSliceCreator = (set) => ({
  personas: {},
  seatOrder: [],
  hydratePersonas: ({ personas, seatOrder }) => {
    set((state) => {
      state.personas = {};
      for (const p of personas) {
        state.personas[p.id] = p;
      }
      state.seatOrder = seatOrder.slice();
    });
  },
  resetPersonas: () => {
    set((state) => {
      state.personas = {};
      state.seatOrder = [];
    });
  },
});
